export enum EmailTypes {
    Normal = 'normal',
    News = 'news',
    Requests = 'requests',
    SalesSubmittal = 'salesSubmittal',
}